module.exports = function chop(str, step) {
  if (str == null) return [];
  str = String(str);
  step = ~~step;
  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/chop.js
// module id = Csax
// module chunks = 0